import { Outlet } from 'react-router';
import { Navigation } from './navigation';
import { useMediaQuery } from '@/hooks/use-media-query';
import { cn } from '@/utils/utils.ts';
import { Suspense } from 'react';
import { useSidebarStore } from '@/services/store/use-sidebar-store.tsx';

const MainLayout = () => {
  const isMobile = useMediaQuery('(max-width:640px)');
  const isExpanded = useSidebarStore((s) => s.isExpanded);

  return (
    <div className="flex min-h-svh">
      <Navigation />
      <main
        className={cn(
          'w-full transform pb-20 transition-all duration-300',
          isMobile ? 'pb-[68px]' : 'pb-8',
          isExpanded && !isMobile ? 'pl-[17rem]' : !isMobile ? 'pl-[5rem]' : 'pl-[0rem]'
        )}
      >
        <Suspense fallback={<div></div>}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
};

export default MainLayout;
